import React from "react";
import { Page, Document, Image, StyleSheet, Font } from "@react-pdf/renderer";
import InvoiceTitle from "./InvoiceTitle";
import BillTo from "./BillTo.js";
import InvoiceItemsTable from "./InvoiceItemsTable";
import InvoicePaymentInfo from "./InvoicePaymentInfo";
import { props } from "lodash/fp";

Font.register({
  family: "HelveticaBold",
  src: "https://db.onlinewebfonts.com/t/50296ce96471759b7ec49aec9ad37f3c.ttf",
  fontWeight: 600,
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 8,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  logo: {
    width: 160,
    height: 37,
    marginBottom: 24,
  },
});

const Invoice = ({ invoice }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Image style={styles.logo} src={`/images/templates/biteship-logo.png`} />
      <InvoiceTitle
        title="Invoice"
        invoiceNumber={`${invoice.invoiceNo}`}
        period={invoice.period}
        issuedAt={invoice.issueDate}
        dueAt={invoice.dueDate}
      />
      <BillTo invoice={invoice} />
      <InvoiceItemsTable invoice={invoice} />
      <InvoicePaymentInfo />
    </Page>
  </Document>
);

export default Invoice;
